import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { StudentsForImpactEditionComponent } from './students-for-impact-edition.component';
import { StudentsForImpactDetailsResolver } from '../students-for-impact-details/students-for-impact-details.resolver';

@NgModule({
    imports: [
      NgbModule,
      SharedModule
    ],
    declarations: [StudentsForImpactEditionComponent],
    exports: [StudentsForImpactEditionComponent],
    providers: [StudentsForImpactDetailsResolver]
  })  
export class StudentsForImpactEditionModule {}